import { useTranslation } from '../../hook/useTranslation';

function ChangeComparisonToggle({ ComparisonType, changeToggle, setChangeToggle }) {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col p-5 justify-center items-center w-full text-base font-bold leading-6 text-center text-white bg-transparent">
      <div className="relative w-[215px] h-[51px] min-h-[48px] flex justify-around items-center gap-[10px] bg-[#EAEAEA] py-[6px] px-[6px] rounded-[25px]">
        <button
          type="button"
          className="z-10 text-[#1E293B] text-[16px] font-[600]"
          onClick={() => setChangeToggle(ComparisonType.Previous)}
          style={{
            color: changeToggle === ComparisonType.Previous ? '#363636' : '#969696',
            fontWeight: changeToggle === ComparisonType.Previous ? 700 : 400,
          }}
        >
          {t('report.comparison.previous')}
        </button>
        <button
          type="button"
          className="z-10 text-[#1E293B] text-[16px] font-[600]"
          onClick={() => setChangeToggle(ComparisonType.Cumulative)}
          style={{
            color: changeToggle === ComparisonType.Cumulative ? '#363636' : '#969696',
            fontWeight: changeToggle === ComparisonType.Cumulative ? 700 : 400,
          }}
        >
          {t('report.comparison.cumulative')}
        </button>
        <div
          className="absolute top-[50%] bg-[#fff] rounded-[25px] h-[39px] z-5"
          style={{
            transform: 'translatey(-50%)',
            transition: '0.2s ease-in-out',
            width: '95px',
            left: `${changeToggle === ComparisonType.Previous ? 7 : 113}px`,
          }}
        />
      </div>
    </div>
  );
}

export default ChangeComparisonToggle;

